import React, { useEffect, useState, useRef } from "react";
import LessonAndAssingmentTab from "./LessonAndAssingmentTab";
import BackButton from "../BackButton/BackButton";
import { useLocation, useParams } from "react-router";
import Pagination from "@mui/material/Pagination";
import { useDispatch, useSelector } from "react-redux";
import { search } from "../../assets/images/images";
import { useAuth } from "../../features/auth/AuthContext";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import "./AssignmentTab.css";
import {
  getAssignmentsByLesson,
  resetAssignmentsList,
} from "../../state/actions/getAssignmentsByLessonAction";
import SearchComponent from "../SearchComponent/SearchComponent";
import SortPopup from '../../pages/customSort/SortPopup';
import { toast } from "react-toastify";
import { resetdeleteAssignment } from "../../state/reducers/deleteAssignmentReducer";
import "./MultiAssignment.css";
import { Grid } from "@mui/material";
import FloatingAIButton from "../FloatingAIButton/FloatingAIButton";
import { setDrawerState, setIsWebAllowed, setQueryMetaData } from "../../state/reducers/chatDrawerReducers";

const MultiAssignment = () => {
  const location = useLocation();
  const { token } = useAuth();
  const itemsPerPage = 12;
  const { lesson_id } = useParams();
  const [nextUrl, setNextUrl] = useState(null);
  const [prevUrl, setPrevUrl] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const globalState = useSelector((state) => state.globalState);
  const role = globalState?.role
  const [searchOption, setsearchOption] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const dispatch = useDispatch();
  const [sortOption, setSortOption] = useState("Newest");



  let UserRoleCourseRights = location?.state?.userRoleCourseRights;

  const isInitialRender = useRef(true);
  const {
    count,
    next,
    previous,
    assignments,
    isLoading,
  } = useSelector((state) => state.getassignmentsbyLesson);
  const [lessonlisting, setlessonlisting] = useState([]);
  const [totalPages, setTotalPages] = useState([]);
  const chatDrawerState = useSelector((state) => state?.ChatDrawerState);
  useEffect(() => {
    if (count !== null) {
      setTotalPages(
        count >= 12
          ? Math.ceil(count / itemsPerPage)
          : Math.floor(count / itemsPerPage)
      );
    }
  }, [count])

  const courseType = location?.state?.course?.course_type

  const roleFromState = location.state?.roleFromState ?? location.state?.role;
  console.log(roleFromState, "assign")

  const teacher_id =
    location.state?.teacher_id ??
    globalState.teacher_details?.data?.teacher_id ??
    "";

  const refreshAssignments = () => {
    dispatch(getAssignmentsByLesson(lesson_id, currentPage, token, courseType, sortOption, searchOption));
    localStorage.removeItem("assignmentanalyticsdetails");
  };
  const deleteAssignment = useSelector((state) => state.deleteAssignment);
  const inial_value = (currentPage - 1) * itemsPerPage;

  useEffect(() => {
    refreshAssignments();
  }, [currentPage, lesson_id, token, dispatch]);

  useEffect(() => {
    setNextUrl(next); // Update next URL
    setPrevUrl(previous); // Update previous URL
    setlessonlisting(assignments);
  }, [assignments, next, previous]);

  useEffect(() => {
    return () => {
      dispatch(resetAssignmentsList());
    };
  }, [dispatch]);

  useEffect(() => {
    if (deleteAssignment?.success) {
      toast.success("Assignment has been deleted successfully.");
      dispatch(resetdeleteAssignment());
    } else if (deleteAssignment?.error?.length) {
      toast.error("Something went wrong.");
      dispatch(resetdeleteAssignment());
    }
    return () => {
      dispatch(resetdeleteAssignment());
    };
  }, [deleteAssignment, dispatch]);

  const handleSortOptionChange = (newSortOption) => {
    setSortOption(newSortOption);
    // Reset page to 1 if you want to reload from first page after sorting
    setCurrentPage(1);

    // Trigger API call immediately with new sortOption
    dispatch(getAssignmentsByLesson(lesson_id, 1, token, courseType, newSortOption, searchOption));

  };

  const handleSortClick = (sortValue) => {
  };

  const handlePageChange = (event, value) => {
    window.scrollTo(0, 0);
    setCurrentPage(value);
  };

  const handleSearch = (e) => {
    setsearchOption(e.target.value);
    setCurrentPage(1);
  };

  useEffect(() => {
    // Skip the initial render to prevent duplicate API calls
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }

    const timeoutId = setTimeout(() => {
      dispatch(getAssignmentsByLesson(lesson_id, 1, token, courseType, sortOption, searchOption));
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [searchOption, lesson_id, token, courseType, dispatch]);
  const accessControl = location?.state?.accessControl;
  function formatDate(isoDate) {
    const date = new Date(isoDate);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getFullYear();

    let suffix = "th";
    if (day % 10 === 1 && day !== 11) {
      suffix = "st";
    } else if (day % 10 === 2 && day !== 12) {
      suffix = "nd";
    } else if (day % 10 === 3 && day !== 13) {
      suffix = "rd";
    }

    return `${day}${suffix} ${month}, ${year}`;
  }



  return (
    <>
      <div className="assignment-list-section">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <BackButton buttonName={"Back"} />
              <div className="assignment-list-section">
                <h2 className="student-Active-Lessons">Assignment</h2>
                <div className="search_header-container">
                  <SearchComponent
                    search={search}
                    searchPlaceholder="Search"
                    searchValue="search"
                    onchange={handleSearch}
                    name="searchOption"
                    value={searchOption}
                  />
                  <div className="filter-wrapper">
                    <div
                      className="lessonviewprogress-filder-tab"
                      onClick={() => {
                        setIsVisible(!isVisible);
                      }}
                    >
                      <span>
                        <i className="fa-solid fa-arrow-down-wide-short"></i>
                      </span>
                      <p>Sort</p>
                      <SortPopup 
                        isVisible={isVisible}
                        ismultipleassignment={true}
                        handleApplyClick={() => { }}
                        sortOption={sortOption}
                        onSortOptionChange={handleSortOptionChange}
                        handleSortClick={handleSortClick}
                        onClose={() => setIsVisible(false)}
                      />
                    </div>
                  </div>
                </div>
                <div className="assignment-list-wraper multi-assignment-list">
                  {isLoading ? (
                    <LoadingComponent />
                  ) : lessonlisting.length > 0 ? (
                    lessonlisting.map((lesson, index) => (
                      <LessonAndAssingmentTab
                        accessControl={accessControl}
                        UserRoleCourseRights={UserRoleCourseRights}
                        key={index}
                        type="Assignment"
                        titleHeader={inial_value + index}
                        title={lesson?.name}
                        Coursename={location?.state?.course?.name}
                        start_date={formatDate(lesson.start_date)}
                        end_date={
                          lesson.end_date != null
                            ? formatDate(lesson.end_date)
                            : "-"
                        }
                        Progress_btn="Assignment Progress"
                        isAssignmentTab={true}
                        course={location?.state?.course}
                        lesson={location?.state?.lesson}
                        lesson_id={lesson_id}
                        courseId={location?.state?.course_id}
                        assignment={lesson}
                        teacher_id={teacher_id}
                        subjecttitle={"Lesson : "}
                        myRole={location?.state?.course?.my_role}
                        Lessonname={location?.state?.lesson?.name}
                        Editbutton={true}
                        refreshAssignments={refreshAssignments} // Pass the refresh function
                        editbtn="edit-assignment"
                        student_enrollment_count={lesson.student_enrollment_count}
                        submission_count={lesson.submission_count}
                        roleFromState={roleFromState}
                      />
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5">No Assignment found.</td>
                    </tr>
                  )}
                  <Grid xs={12} container justifyContent={"center"}>
                    <Pagination
                      count={totalPages}
                      page={currentPage}
                      onChange={handlePageChange}
                      color="primary"
                      hideNextButton={
                        nextUrl === null || nextUrl === undefined || currentPage === totalPages
                      }
                      hidePrevButton={prevUrl === null || prevUrl === undefined || currentPage === 1}
                    />
                  </Grid>
                </div>
                { role !== "Admin" &&
                <FloatingAIButton
                  onClick={() => {
                    dispatch(setDrawerState(!chatDrawerState.isOpen));
                    dispatch(setIsWebAllowed(true));
                    dispatch(setQueryMetaData(null));
                  }}
                />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MultiAssignment;
